// extracted by mini-css-extract-plugin
export default {"card":"Showproducts_card__zXpBv","body":"Showproducts_body__qpM85","mt-3":"Showproducts_mt-3__lCBKX","img":"Showproducts_img__Nsiow"};